import * as tslib_1 from "tslib";
import { lazyGetGroupDisplayName } from 'owa-group-utils';
import { default as createComposeViewState, } from './createComposeViewState';
export default function createGroupComposeViewState(props) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var getGroupDisplayName, groupDisplayName, composeViewState, groupComposeViewState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(props.operation != 3 /* Forward */ && !hasGroupInToRecipients(props))) return [3 /*break*/, 3];
                    if (!props.to) {
                        props.to = [];
                    }
                    return [4 /*yield*/, lazyGetGroupDisplayName.import()];
                case 1:
                    getGroupDisplayName = _a.sent();
                    return [4 /*yield*/, getGroupDisplayName(props.groupId)];
                case 2:
                    groupDisplayName = _a.sent();
                    props.to.push({
                        EmailAddress: props.groupId,
                        Name: groupDisplayName,
                        RoutingType: 'SMTP',
                        MailboxType: 'GroupMailbox',
                    });
                    _a.label = 3;
                case 3: return [4 /*yield*/, createComposeViewState(props)];
                case 4:
                    composeViewState = _a.sent();
                    groupComposeViewState = composeViewState;
                    groupComposeViewState.groupId = props.groupId;
                    // For replyAll scenario, we do not allow user to remove group from to line
                    if (props.operation === 2 /* ReplyAll */) {
                        markGroupRecipientAsBlockedFromRemoval(props.groupId, groupComposeViewState.toRecipientWell);
                    }
                    return [2 /*return*/, groupComposeViewState];
            }
        });
    });
}
function hasGroupInToRecipients(props) {
    if (!props.to) {
        return false;
    }
    for (var _i = 0, _a = props.to; _i < _a.length; _i++) {
        var recipient = _a[_i];
        if (recipient.EmailAddress == props.groupId) {
            return true;
        }
    }
    return false;
}
function markGroupRecipientAsBlockedFromRemoval(groupId, toRecipientWell) {
    for (var _i = 0, _a = toRecipientWell.recipients; _i < _a.length; _i++) {
        var recipient = _a[_i];
        if (recipient.persona.EmailAddress.MailboxType == 'GroupMailbox' &&
            recipient.persona.EmailAddress.EmailAddress == groupId) {
            recipient.blockRecipientRemoval = true;
            break;
        }
    }
}
//# sourceMappingURL=createGroupComposeViewState.js.map